module.exports = __webpack_public_path__ + "img/5S.74c699bb.svg";